import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box
} from '@mui/material';
import { useOrderStore } from '../store/useOrderStore';
import { useNavigate } from 'react-router-dom';

export default function OrderHistory() {
  const { order } = useOrderStore();
  const navigate = useNavigate();

  return (
    
    <Box sx={{ padding: '10px', backgroundColor: 'rgb(245, 245, 245)',border: '1px solid #ccc',borderRadius: "4px" }}>
      <TableContainer>
        <Table aria-label="order table">
          <TableHead>
            <TableRow>
              <TableCell><strong>Product</strong></TableCell>
              <TableCell><strong>Order ID</strong></TableCell>
              <TableCell><strong>Price</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell align="center"><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(order || []).map((ele) => (
              <TableRow key={ele._id}>
                <TableCell>
                  {ele?.items?.[0]?.productDetails?.images?.[0] ? (
                    <img
                      src={ele.items[0].productDetails.images[0]}
                      alt="Product"
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'contain',
                        borderRadius: '4px',
                        border: "1px solid #2D3C67",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No Image
                    </Typography>
                  )}
                </TableCell>
                <TableCell>{ele?.orderId}</TableCell>
                <TableCell>${ele?.totalAmountBeforeCoupon}</TableCell>
                <TableCell>
                  <Typography color="green">{ele?.status}</Typography>
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: '#2874f0',
                      color: '#fff',
                      textTransform: 'none',
                      '&:hover': { backgroundColor: '#1a5dcc' },
                    }}
                    onClick={() => navigate(`/order-detail/${ele._id}`)}
                  >
                    View Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {order.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
